import CheckLuhn from "../../../../utils/Luhn";
import { findCardType } from "../../../../utils/BinUtils";

export default number => {
  const trimmedNumber = number.replace(/\s+/g, "");
  if (trimmedNumber.length === 0) {
    return { showError: true, errorMsg: undefined };
  }
  const cardType = findCardType(number);
  if (cardType === "AMEX") {
    return {
      showError: true,
      errorMsg: "American Express cards are not supported"
    };
  }
  if (!CheckLuhn(trimmedNumber) || trimmedNumber.length < 16) {
    return { showError: true, errorMsg: "Invalid card number" };
  }
  return { showError: false, errorMsg: undefined };
};
